import { useQuery } from '@tanstack/react-query'

import { getScimConfiguration } from '@src/api'
import { DefaultApiGetScimConfigurationRequest } from '@src/api/generated/iam'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchScimConfiguration = (
  params: DefaultApiGetScimConfigurationRequest
) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getScimConfiguration(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_SCIM_CONFIGURATION,
      params.organizationId,
    ],
  })
}
